import moment from 'moment';

export const RANGE_PRESETS = [
  {
    key: 'today',
    getRange: () => ({ start: moment(), end: moment() })
  },
  {
    key: 'yesterday',
    getRange: () => ({ start: moment().subtract(1, 'days'), end: moment().subtract(1, 'days') })
  },
  {
    key: 'last_7_days',
    getRange: () => ({ start: moment().subtract(6, 'days'), end: moment() })
  },
  {
    key: 'last_30_days',
    getRange: () => ({ start: moment().subtract(29, 'days'), end: moment() })
  },
  {
    key: 'last_90_days',
    getRange: () => ({ start: moment().subtract(89, 'days'), end: moment() })
  },
  {
    key: 'last_12_months',
    getRange: () => ({
      start: moment()
        .subtract(12, 'months')
        .add(1, 'day'),
      end: moment()
    })
  },
  {
    key: 'this_month',
    getRange: () => ({ start: moment().startOf('month'), end: moment().endOf('month') })
  },
  {
    key: 'last_month',
    getRange: () => ({
      start: moment()
        .subtract(1, 'month')
        .startOf('month'),
      end: moment()
        .subtract(1, 'month')
        .endOf('month')
    })
  },
  {
    key: 'this_year',
    getRange: () => ({ start: moment().startOf('year'), end: moment().endOf('year') })
  },
  {
    key: 'last_year',
    getRange: () => ({
      start: moment()
        .subtract(1, 'year')
        .startOf('year'),
      end: moment()
        .subtract(1, 'year')
        .endOf('year')
    })
  }
];

export const getPresetRange = key => {
  const preset = RANGE_PRESETS.find(candidate => candidate.key === key);

  return preset ? preset.getRange() : null;
};

export const getLast12MonthsRange = () => {
  const { start, end } = getPresetRange('last_12_months');

  return { startDate: start, endDate: end };
};

export const isRangeValid = (start, end) => !!start && !!end && moment(start).isSameOrBefore(moment(end), 'day');

export const findMatchingPresetKey = (start, end) => {
  if (!start || !end) return null;

  const match = RANGE_PRESETS.find(({ getRange }) => {
    const range = getRange();

    return moment(start).isSame(range.start, 'day') && moment(end).isSame(range.end, 'day');
  });

  return match ? match.key : null;
};
